import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyAozCGLqG8PfdhEe_60irDN6h9OZVWYdVE',
  authDomain: 'accord-4cc08.firebaseapp.com',
  projectId: 'accord-4cc08',
  storageBucket: 'accord-4cc08.firebasestorage.app',
  messagingSenderId: '80188461915',
  appId: '1:80188461915:web:c2860a4d9fa3f8d90c007e',
  measurementId: 'G-0QEWRLSJHX'
};

// 初始化 Firebase
const app = initializeApp(firebaseConfig);

// 初始化 Firebase 服务
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

// 配置 Google 登录提供商
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Lazy analytics init to avoid SSR/build issues
let analyticsPromise: Promise<ReturnType<typeof getAnalytics>> | null = null;
export const initAnalytics = () => {
  if (!analyticsPromise) {
    analyticsPromise = isSupported().then((supported) => (supported ? getAnalytics(app) : (null as any)));
  }
  return analyticsPromise;
};

export default app;


